import { render, staticRenderFns } from "./AcademyBioPanel.vue?vue&type=template&id=85856902&"
import script from "./AcademyBioPanel.vue?vue&type=script&lang=js&"
export * from "./AcademyBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports